import React, {Fragment} from "react";
import {
    ArrowIcon, CustomContainer,
    CustomHeader,
    CustomTableRow,
    CustomTD,
    Dot,
    OptionContainer,
    OptionsContainer,
    StatusSpan,
    StyledTable,
    StyledTableHeaderCell
} from "@pages/new-design-components/custom-components";
import ThreeDots from "@assets/images/mi_options-vertical.svg";
import {UncontrolledPopover} from "reactstrap";
import {badgeColors, checkAndFormatShortGb, fleetNewStatuses, formatNumber, parseToWord} from "@constants/index";
import {LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import CustomDamageDropDown from "@pages/components/JobDetailsComponents/CustomDropDown";
import CustomDropdownComponent from "@pages/components/JobDetailsComponents/CustomInspectionDropDown";

export default function DebtManagementTable({keys,tableData = [],viewDetails, optionValues, loading = false,download,filter,setOrderItem, selectValue}) {

    const generateItem = ({item,index,key, itemIndex, select, selectContainer}) => {
        if (key === 'no_of_outstanding') {
            return (
                <CustomTD key={index} color={'#EB5855'}>
                    {item.no_of_outstanding}
                </CustomTD>
            );
        } else if (key === 'no_of_overdue') {
            return (
                <CustomTD key={index} color={'#EB5855'}>
                    {item.no_of_overdue}
                </CustomTD>
            );
        }
        else if (key === 'status') {

            return (
                <CustomTD key={index} color={'#EB5855'}>
                    {
                        select ?
                            <CustomDropdownComponent
                                withoutDot
                                noBadge
                                selectedTitle={item?.status}
                                statusArrayKey={selectContainer}
                                handleChange={(value)=>{
                                   selectValue({id:item.id,key,value})
                                }}
                            />
                            :
                              item?.status
                    }
                </CustomTD>
            );
        }
        else if (key === 'payment_manager') {
            return (
                <CustomTD key={index}>
                    {item?.payment_manager?.name}
                </CustomTD>
            );
        }
        else if (key === 'overdue_duration') {
            return  <CustomTD key={index} color={'#EB5855'}>
                {item[key] || 0} days
            </CustomTD>
        } else if ( key === 'new_status') {
            const customKey = key === 'new_status' ? 'status' : key;
            const xeroCustomer = item.xero_customer || [];
            const value = xeroCustomer[0]?.[customKey];
            const stat = fleetNewStatuses['debtListStatuses'].find(status => status.key === value);
            return (
                <CustomTD key={index} color="#EB5855">
                    {value && stat ? parseToWord(stat?.title) : '-'}
                </CustomTD>
            );
        } else if (key === 'debt_recovery_status' || key === 'debt_recovery_decision') {
            const xeroCustomer = item.xero_customer
            const specialKey = key.split("_").pop();
            const value = xeroCustomer[0]?.debt_recovery?.at(-1)?.[specialKey] ?? '-';
            return  <CustomTD key={index} color={'#EB5855'}>
                {parseToWord(value)}
            </CustomTD>
        } else if ( key === 'expected_payment_date') {
            const xeroCustomer = item.xero_customer[0]
            let value = parseToWord(xeroCustomer[key]?.toString())
            return  <CustomTD key={index}>
                <IcoMoon
                    iconSet={IconSet}
                    icon={'ic_calendar'}
                    size={24}
                />
                {checkAndFormatShortGb(value)}</CustomTD>
        }
         else if (key === 'customer_name_deep') {
            return <CustomTD key={index}>
                {item.customer.first_name} {item.customer.last_name}
            </CustomTD>
        } else if (key === 'mobile_number_deep') {
            return <CustomTD key={index}>
                {item.customer.mobile_number}
            </CustomTD>
        } else if (key === 'view') {
            return  <CustomTD key={index} color={'#3F8CFF'} onClick={()=>{ viewDetails(itemIndex) }}
                              className={'text-center cursor-pointer'}
            >  View </CustomTD>
        } else if (key === 'debt_status') {
            return  <CustomTD key={index} color={'#3F8CFF'} onClick={()=>{ viewDetails(itemIndex) }}
                              className={'cursor-pointer'}
            >
                <Dot width={'12px'} color={badgeColors(item.debt_status)}/>
                <StatusSpan type={item.debt_status}>
                    {parseToWord(item.debt_status) || 'N/A'}
                </StatusSpan>
            </CustomTD>
        } else if (key === 'amount_due') {
            return <CustomTD key={index} color={'#219852'}>
                £{formatNumber(item.amount_due)}
            </CustomTD>
        } else if (key === 'customer_debt_sum_amount_due') {
            return <CustomTD key={index} color={'#EB5855'}>
                £{formatNumber(item?.customer_debt_sum_amount_due)}
            </CustomTD>
        } else if (key === 'vehicle') {
            return <CustomTD key={index}>
               {item?.vehicle?.derivative || '-'}
            </CustomTD>
        } else if (key === 'vehicle_deep') {
            return <CustomTD key={index}>
                <a href={`/admin/vehicle/${item.vehicle_id}/edit`} target='_blank'>
                 {`${item?.vehicle?.vehicle_make.name} ${item?.vehicle?.vehicle_model.name} ${item?.vehicle?.stock_no}` || '-'}
                </a>
            </CustomTD>
        }  else if (key === 'download') {

            return <CustomTD key={index}>
                <IcoMoon
                    onClick={()=>{
                        download(itemIndex)
                    }}
                    className={'cursor-pointer'}
                    iconSet={IconSet}
                    icon={'download'}
                    size={24}
                />
            </CustomTD>
        }  else if (key === 'overdue_duration_nested') {
            const dueDate = new Date(item.due_date);
            const todayDate = new Date();
            const overdueDuration = Math.floor((todayDate - dueDate) / (1000 * 60 * 60 * 24));
            return  <CustomTD key={index} color={'#EB5855'}>
                      {overdueDuration} days
            </CustomTD>
        }  else if (key === 'options') {
            return  <CustomTD key={index} color={'#3F8CFF'}
                              className={'text-center cursor-pointer'}
            >    <img src={ThreeDots} id={`PopoverLegacy_${index}`} />
                <UncontrolledPopover
                    placement="left"
                    className="fleet-popover"
                    target={`PopoverLegacy_${index}`}
                    trigger="legacy"
                >
                    <OptionsContainer className={'cursor-pointer'}>
                        {optionValues.map(item=>{
                            return (   <OptionContainer
                                    onClick={()=>{
                                        item['action'](itemIndex)
                                    }}
                                >
                                    <CustomHeader  fontSize={'14px'} weight={'400'}>
                                        {item['label']}
                                    </CustomHeader>

                                </OptionContainer>

                            )
                        })}
                    </OptionsContainer>
                </UncontrolledPopover>
            </CustomTD>

        } else if (key === 'due_date' || key === 'date' || key === 'created_at') {
            let value = parseToWord(item[key]?.toString())
            return  <CustomTD key={index}>
                    <IcoMoon
                        iconSet={IconSet}
                        icon={'ic_calendar'}
                        size={24}
                    />
                    {checkAndFormatShortGb(value)}</CustomTD>
        }
        return <CustomTD key={index}>
            {item[key] ? item[key] : '-'}
        </CustomTD>
    }
    return (
        loading ?
                <LoaderContainer>
                    <ClipLoader
                        css={override}
                        size={40}
                        color={`#7B61E4`}
                        loading={loading}
                    />
                </LoaderContainer>
            :
            tableData.length ?
        <StyledTable className={'table-borderless'}>

            <thead className={'header-white-text'}>
            <tr>
                {keys.map((item,index)=>{
                    return    <Fragment key={`${index}_hd`}>
                        <StyledTableHeaderCell fontSize='14px' color={'#0000008C'} onClick={()=>{
                            if (item?.sort) {
                                setOrderItem({order_by: item.key, order: (filter.order_by === item.key) ? (filter.order === 'asc' ? 'desc' : 'asc') : 'asc'})
                            }
                        }}>
                            {item.label}
                            {item?.sort &&    <ArrowIcon
                                isOpen={(filter.order_by === item.key) ? filter.order === 'asc' : false}
                                src={require("assets/images/arrow_forward_ios.png")}
                                alt="Dropdown Arrow"
                            />}
                        </StyledTableHeaderCell>
                    </Fragment>
                })}

            </tr>
            </thead>
            <tbody>
            {
                tableData.map((item,index)=>{
                    return <CustomTableRow key={`${index}_td`}>
                        {
                            keys.map(({key, selectContainer = null, select = null}, keyIndex) => {
                                return generateItem({item, index: `${index}_${keyIndex}`,key, itemIndex: index, select, selectContainer});
                            })
                        }
                    </CustomTableRow>

                })
            }
            </tbody>
        </StyledTable>
          :  <CustomContainer borderRadius="8px" padding="10px 16px" textAlign={'center'} contentAlign={'center'} height={'150px'}>
                    <CustomHeader>
                        Empty Data
                    </CustomHeader>
                </CustomContainer>
    )
}